import { Header, Footer } from '@/components/layout'
import { SEO } from '@/components/seo'

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-surface-950">
      <SEO
        title="Privacy Policy"
        description="JumpstoneAuth Privacy Policy. Learn how we collect, use, and protect your personal information."
        canonical="/privacy"
      />
      <Header />
      <main className="pt-24 pb-16">
        <div className="mx-auto max-w-7xl section-padding">
          <h1 className="text-4xl font-bold text-white mb-4">Privacy Policy</h1>
          <p className="text-lg text-surface-400">Last updated: January 2026</p>
        </div>
      </main>
      <Footer />
    </div>
  )
}

